/*
 * WorkAndBuhin.vue の close 時 action と onclose payload を切り出した処理。
 */
export interface WorkBuhinClosePayload {
  isChange: boolean;
  isSocket: boolean;
  isResetSeibi: boolean;
}

export interface WorkBuhinCloseActionState {
  showConfirmDialog2: boolean;
  showWork: boolean;
  shouldRemoveEditMode: boolean;
  shouldFilterSeibi: boolean;
  shouldEmitOnClose: boolean;
  payload: WorkBuhinClosePayload;
}

export interface WorkBuhinCloseApplyEffectState {
  showConfirmDialog2: boolean;
  showWork: boolean;
  shouldRemoveEditMode: boolean;
  shouldFilterSeibi: boolean;
  shouldEmitOnClose: boolean;
  payload: WorkBuhinClosePayload;
}

/*
 * buildWorkBuhinCloseActionState を WorkAndBuhin.vue から分離し、
 * close 時の親表示 state 更新、edit mode 解除、onclose payload の契約を固定するため。
 */
export function buildWorkBuhinCloseActionState(params: {
  isChange: boolean;
  isSocket: boolean;
  isResetSeibi: boolean;
}): WorkBuhinCloseActionState {
  return {
    showConfirmDialog2: false,
    showWork: false,
    shouldRemoveEditMode: true,
    shouldFilterSeibi: false,
    shouldEmitOnClose: true,
    payload: {
      isChange: params.isChange,
      isSocket: params.isSocket,
      isResetSeibi: params.isResetSeibi
    }
  };
}

/*
 * buildWorkBuhinCloseApplyEffectState を WorkAndBuhin.vue から分離し、
 * close 時の component 側 state 反映、edit mode 解除、onclose emit 条件を固定するため。
 */
export function buildWorkBuhinCloseApplyEffectState(
  actionState: WorkBuhinCloseActionState
): WorkBuhinCloseApplyEffectState {
  return {
    showConfirmDialog2: actionState.showConfirmDialog2,
    showWork: actionState.showWork,
    shouldRemoveEditMode: actionState.shouldRemoveEditMode,
    shouldFilterSeibi: actionState.shouldFilterSeibi,
    shouldEmitOnClose: actionState.shouldEmitOnClose,
    payload: actionState.payload
  };
}
